'use strict';

(function () {
    'use strict';

    httpConfig.$inject = ['$httpProvider'];
    angular.module('app').config(httpConfig).constant('appConfig', {
        apiUrl: 'https://smartcity.heraklion.gr/open-data-api',
        peopleUrl: 'https://people.smartcity.heraklion.gr/api',
        soundUrl: 'https://sound.smartcity.heraklion.gr/api',
        trafficUrl: 'https://traffic.smartcity.heraklion.gr/api',
        // apiUrl: 'http://139.91.183.37:3000',
        googleMaps: {
            apiUrl: 'https://maps.google.com/maps/api/js?key=AIzaSyBevwPasu0wsZ6wi4J0CYaHP1AGkuqfh_g',
            styles: [{ "featureType": "administrative", "elementType": "all", "stylers": [{ "saturation": "-100" }] }, { "featureType": "administrative.province", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 65 }, { "visibility": "on" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": "50" }, { "visibility": "simplified" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": "-100" }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "all", "stylers": [{ "lightness": "30" }] }, { "featureType": "road.local", "elementType": "all", "stylers": [{ "lightness": "40" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "hue": "#ffff00" }, { "lightness": -25 }, { "saturation": -97 }] }, { "featureType": "water", "elementType": "labels", "stylers": [{ "lightness": -25 }, { "saturation": -100 }] }]
        }
    });

    function httpConfig($httpProvider) {
        'ngInject';

        authenticationInterceptors.$inject = ['$q', 'localStorageService'];
        function authenticationInterceptors($q, localStorageService) {
            'ngInject';

            return {
                'request': function request(config) {
                    var user = localStorageService.get('authUser');

                    if (user && moment().diff(user.timestamp, 'seconds') <= 86400 && user.token) {
                        config.headers.authorization = 'Bearer ' + user.token;
                    }

                    return config;
                }
            };
        }

        $httpProvider.interceptors.push(authenticationInterceptors);
    }
})();